import { getCommandResult } from "./api"

export const commandError = message => ({
  SUPER_ADMIN_REQUIRED: "Only an activated super admin can manage administrative accounts.",
  CANNOT_DISABLE_OWN_ACCOUNT: "You cannot disable or demote your own account.",
  LAST_ACTIVE_SUPER_ADMIN: "At least one activated super admin must remain.",
  EMAIL_ALREADY_EXIST: "This email is already used by another account.",
  DELETED_ACCOUNT_READ_ONLY: "Deleted accounts cannot be edited.",
  INVALID_ADMIN_FIELDS: "Review the account fields before trying again.",
})[message] || "The operation could not be completed. Check your access and try again."

export function runAdminCommand({ submit, socket, correlationId, verifyOnly = false, timeoutMs = 30000, intervalMs = 1500 }) {
  const id = correlationId || Array.from(window.crypto.getRandomValues(new Uint32Array(4))).join("-")
  let finished = false, reading = false, timer, deadline, resolve
  const promise = new Promise(done => { resolve = done })
  const finish = result => {
    if (finished) return
    finished = true
    clearTimeout(timer)
    clearTimeout(deadline)
    socket?.off("accounts-response", onResponse)
    resolve(result)
  }
  const read = async () => {
    if (finished || reading) return
    clearTimeout(timer)
    reading = true
    try {
      const { data } = await getCommandResult(id)
      if (data?.state === "completed") finish(data.success
        ? { status: "saved", accountId: data.accountId, warning: data.warning }
        : { status: "error", message: commandError(data.message) })
    } catch (error) {
      // A failed read cannot prove whether the command has committed.
    } finally {
      reading = false
      if (!finished) timer = setTimeout(read, intervalMs)
    }
  }
  const onResponse = response => {
    if (response?.correlationId === id) read()
  }
  socket?.on("accounts-response", onResponse)
  deadline = setTimeout(() => finish({ status: "unknown" }), timeoutMs)
  const start = async () => {
    if (!verifyOnly) {
      try {
        const accepted = await submit(id)
        if (accepted?.success === false) { finish({ status: "error", message: commandError(accepted.message) }); return }
      } catch (error) {
        if (error.response?.status >= 400 && error.response?.status < 500) {
          finish({ status: "error", message: commandError(error.response.data?.message) })
          return
        }
      }
    }
    read()
  }
  start()
  return { promise, correlationId: id, cancel: () => finish({ status: "cancelled" }) }
}
